import { render, staticRenderFns } from "./NewUI.vue?vue&type=template&id=2ee17eec"
import script from "./NewUI.vue?vue&type=script&lang=js"
export * from "./NewUI.vue?vue&type=script&lang=js"
import style0 from "./NewUI.vue?vue&type=style&index=0&id=2ee17eec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports